import { render, staticRenderFns } from "./AtencionDescansoMedico.vue?vue&type=template&id=50fe9b20"
import script from "./AtencionDescansoMedico.vue?vue&type=script&lang=js"
export * from "./AtencionDescansoMedico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports